"use client";

import type React from "react";

import { AlertTriangle } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

import { ErrorBoundary } from "./error-boundary";

interface SafeComponentProps {
  children: React.ReactNode;
  fallbackMessage?: string;
  componentName?: string;
}

function ComponentErrorFallback({
  error: _error,
  reset,
  message,
  componentName,
}: {
  error: Error;
  reset: () => void;
  message: string;
  componentName?: string;
}) {
  return (
    <Alert className="my-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription>
        <p className="font-medium">{message}</p>
        {componentName && <p className="mt-1 text-sm text-muted-foreground">Component: {componentName}</p>}
        <button onClick={reset} className="mt-2 text-sm text-primary hover:underline">
          Try reloading
        </button>
      </AlertDescription>
    </Alert>
  );
}

export function SafeComponent({
  children,
  fallbackMessage = "This section couldn't load properly",
  componentName,
}: SafeComponentProps) {
  return (
    <ErrorBoundary
      fallback={(props) => (
        <ComponentErrorFallback {...props} message={fallbackMessage} componentName={componentName} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
